var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper sections-page"},[_c('headers'),_c('features'),_c('blogs'),_c('teams'),_c('projects'),_c('pricing'),_c('testimonials'),_c('contact'),_c('tables'),_c('accordion')],1)}
var staticRenderFns = []

export { render, staticRenderFns }